export default __webpack_public_path__ + "static/media/@westreamer.6da58832.jpeg";